import React from "react";

interface ScrollingInfoBannerProps {
  messages?: string[];
}

const ScrollingInfoBanner: React.FC<ScrollingInfoBannerProps> = ({
  messages = [
    "Livraison gratuite a partir de 15 000 F",
    "En dessous de 15 000 Livraison à 2000 F",
  ]
}) => {
  return (
    // <div className="scrolling-info-banner">
    //   <div className="scrolling-info-content">
    //     {messages.map((message, index) => (
    //       <span key={index} className="scrolling-info-item">
    //         {message}
    //       </span>
    //     ))}
    //     {/* Dupliquer les messages pour un défilement continu */}
    //     {messages.map((message, index) => (
    //       <span key={`duplicate-${index}`} className="scrolling-info-item">
    //         {message}
    //       </span>
    //     ))}
    //   </div>
    // </div>
    <></>
  );
};

export default ScrollingInfoBanner;
